import { MouseEvent, useState } from 'react'

import PowerSettingsNew from '@mui/icons-material/PowerSettingsNew'
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tooltip,
  Typography
} from '@mui/material'
import { logout } from '@/service/authService'
import { useAuthStore } from '@/stores/useAuthStore'

import { PlatformDependent } from '../PlatformDependent'
import { ThemeModeSwitch } from '../ThemeModeSwitch'
import { CurrentUserAvatar } from '../UserAvatar/CurrentUserAvatar'
import { WSAuthToken } from '../WSAuthToken'
import { StyledMenu } from './AvatarMenu.styled'

export const openMenuTestId = 'open-menu'
export const userFullnameTestId = 'user-fullname'
export const userEmailTestId = 'user-email'

export const AvatarMenu = () => {
  const [menuAnchorEl, setMenuAnchorElUser] = useState<null | HTMLElement>(null)
  const user = useAuthStore((state) => state.user)

  const onAvatarClick = (event: MouseEvent<HTMLElement>) => setMenuAnchorElUser(event.currentTarget)

  const closeMenu = () => setMenuAnchorElUser(null)

  const onLogout = () => {
    logout()
    closeMenu()
  }

  return (
    <>
      <Tooltip title="Open Settings">
        <IconButton color="inherit" onClick={onAvatarClick} data-testid={openMenuTestId}>
          <CurrentUserAvatar />
        </IconButton>
      </Tooltip>

      <StyledMenu anchorEl={menuAnchorEl} open={!!menuAnchorEl} onClose={closeMenu}>
        <Box px={1.5} pt={1.5}>
          <PlatformDependent streaming>
            <Typography fontWeight={500} data-testid={userFullnameTestId}>
              {user?.name}
            </Typography>
          </PlatformDependent>
          <Typography data-testid={userEmailTestId}>{user?.email}</Typography>
        </Box>

        <MenuItem divider disableRipple className="disableHover">
          <ThemeModeSwitch />
        </MenuItem>

        <PlatformDependent dde>
          <WSAuthToken />
        </PlatformDependent>

        <MenuItem onClick={onLogout}>
          <ListItemIcon>
            <PowerSettingsNew />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </StyledMenu>
    </>
  )
}
